import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import '../App.css';
import { useAuth } from '../context/AuthContext';

const PAGE_TITLES = {
  overview: 'Dashboard',
  distributors: 'Distributor Enquiries',
  'super-stockists': 'Super Stockist Enquiries',
  'location-master': 'Location Master',
  'mail-ids': 'Map Email IDs',
  'distributor-bin': 'Distributor Bin',
  'super-stockist-bin': 'Super Stockist Bin',
};

function Dashboard({ children }) {
  const [collapsed, setCollapsed] = useState(false);
  const [active, setActive] = useState('overview');
  const { user, logout } = useAuth();

  useEffect(() => {
    document.title = `${PAGE_TITLES[active] || 'Admin'} | Hindustan Pencils`;
  }, [active]);

  const selectSection = section => {
    setActive(section);
    if (window.matchMedia('(max-width: 720px)').matches) setCollapsed(true);
  };

  return (
    <div className="layout-root">
      <Header onToggleSidebar={() => setCollapsed(c => !c)} user={user} onLogout={logout} />
      <div className="layout-body">
        <Sidebar collapsed={collapsed} active={active} onSelect={selectSection} />
        <main className="main-content">
          {React.isValidElement(children) ? React.cloneElement(children, { activeSection: active, onNavigate: selectSection }) : children}
        </main>
      </div>
    </div>
  );
}

export default Dashboard;
